var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPhoneIphone = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2767_551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2502 0.791687H3.9585V18.2084H14.2502V0.791687ZM9.10433 17.4167C8.44725 17.4167 7.91683 16.8863 7.91683 16.2292C7.91683 15.5721 8.44725 15.0417 9.10433 15.0417C9.76141 15.0417 10.2918 15.5721 10.2918 16.2292C10.2918 16.8863 9.76141 17.4167 9.10433 17.4167ZM12.6668 14.25H5.54183V3.16669H12.6668V14.25Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2767_551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPhoneIphone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/phone_iphone.e7e1006d.svg";
export { ForwardRef as ReactComponent };